import React, { useEffect, useRef } from 'react';
import axios from "axios";

const FindApiLink = ({ href, children, ...props }) => {
    const findApiRef = useRef({
        _applicationUrl: "/",
        _serviceApiBaseUrl: "/api/stats/trackhit",
        _trackId: "",
        _trackParam: "_tr_",
      
        _getTrackQueryParamsFromUrl: function (url) {
            // Extract query parameters from URL
            const queryString = url.split('?')[1] || '';
            if (!queryString) return { trackQueryParams: [], nonTrackQueryParams: [] };

            const allParams = queryString.split('&');
            const trackParams = [];
            const nonTrackParams = [];

            allParams.forEach(param => {
                if (param.startsWith(this._trackParam) || param.indexOf('id') === 0) {
                    trackParams.push(param);
                } else {
                    nonTrackParams.push(param);
                }
            });

            return {
                trackQueryParams: trackParams,
                nonTrackQueryParams: nonTrackParams
            };
        },  
        _getUriWithoutTrackParams: function (e, t) {
            return t.trackQueryParams.length > 0 && t.nonTrackQueryParams.length > 0
                ? e.split("?")[0] + "?" + t.nonTrackQueryParams.join("&")
                : t.trackQueryParams.length > 0
                    ? e.split("?")[0]
                    : undefined;
        }
    });

    const handleClick = (event) => {
        // Prevent default behavior
        event.preventDefault();

        const findApi = findApiRef.current;
        const a = event.currentTarget;
        const r = document.createElement("a");
       
        r.href = document.location.href;

        const trackQueryParams = findApi._getTrackQueryParamsFromUrl(a.href);
        let hasIdParam = false;

        for (let i = 0; i < trackQueryParams.trackQueryParams.length; i++) {
            if (trackQueryParams.trackQueryParams[i].indexOf("id") === 4) {
                hasIdParam = true;
                break;
            }
        }

        if (trackQueryParams.trackQueryParams.length > 0 && hasIdParam) {
            const c = document.createElement("a");
            c.href = a.href;

            const appUrlCondition =
                findApi._applicationUrl !== "/" &&
                r.hostname + findApi._applicationUrl !== c.hostname + "/" + c.pathname.split("/")[1] + "/";
                
            if (appUrlCondition || findApi._applicationUrl === "/") {
 
                if (a.href.split("?")[0].indexOf(findApi._serviceApiBaseUrl) !== -1) {
            
                    window.location.href = a.href;
                    return;
                }

                // Add additional API call for click tracking
                const clickApiUrl = `${findApi._serviceApiBaseUrl}?url=${encodeURIComponent(a.href)}&referrer=${encodeURIComponent(document.referrer)}`;

                const fetchData = async () => {
                    try {
                        await axios.post(
                            clickApiUrl, {
                            trackParams: trackQueryParams.trackQueryParams,
                            timestamp: new Date().getTime()
                        });
                       
                    } catch (errorData) {
                       
                    } finally {
                        // Still navigate even if API call fails
                        const cleanUrl = findApi._getUriWithoutTrackParams(a.href, trackQueryParams);
                        window.location.href = cleanUrl || a.href;
                    }
                };

                fetchData();

            } else {
                // Just navigate normally if no tracking is needed for this domain
                window.location.href = a.href;
            }
        } else {
            // Just navigate normally if no tracking is needed
            window.location.href = a.href;
        }
    };

    return (
        <a href={href} onClick={handleClick} {...props}>
            {children}
        </a>
    );
};

export default FindApiLink;